class UserApplicationDetailModel {
  applicationId: string;
  applicationNumber: string;
  applicationType: 'DEFAULT' | 'OFFLINE' | 'OFFLINE_EXAM_SUBMISSION';
  userApplicationDetails: Array<{
    userApplicationId: string;
    userId: string;
    identity: 'PARENT' | 'STUDENT';
  }>;

  isStudentApplicationExist: boolean | undefined;
  isParentApplicationExist: boolean | undefined;
  isParentLoggedIn: boolean | undefined;

  constructor(applicationData: any, loggedInUserId: string) {
    const {
      application_id,
      application_number,
      user_application_details,
      meta_data
    } = applicationData;
    this.applicationId = application_id;
    this.applicationNumber = application_number;
    if (meta_data) {
      const metaData = JSON.parse(meta_data);
      if (metaData.application_type) {
        this.applicationType = metaData.application_type;
      } else {
        this.applicationType = 'DEFAULT';
      }
    } else {
      this.applicationType = 'DEFAULT';
    }

    if (user_application_details) {
      this.userApplicationDetails = user_application_details.map(
        (eachDetail) => {
          return {
            userApplicationId: eachDetail.user_application_id,
            userId: eachDetail.user_id,
            identity: eachDetail.identity
          };
        }
      );

      this.isStudentApplicationExist =
        this.userApplicationDetails.findIndex(
          (eachDetail) => eachDetail.identity === 'STUDENT'
        ) !== -1;
      this.isParentApplicationExist =
        this.userApplicationDetails.findIndex(
          (eachDetail) => eachDetail.identity === 'PARENT'
        ) !== -1;
      this.isParentLoggedIn =
        this.userApplicationDetails.findIndex(
          (eachDetail) =>
            eachDetail.userId === loggedInUserId &&
            eachDetail.identity === 'PARENT'
        ) !== -1;
    }
  }
}

export { UserApplicationDetailModel };
